import React from "react";
import { Stack, StackProps, Typography } from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";

type ProgressSectionProps = {
  direction: StackProps["direction"];
  title: string;
  description: string;
  image: string;
};

export const ProgressSection: React.FC<ProgressSectionProps> = (props) => {
  const { description, title, direction, image } = props;

  return (
    <Stack maxWidth="lg" direction={direction} spacing={4}>
      <Stack direction="column">
        <Typography variant="h6" color={blueGrey[700]}>
          {title}
        </Typography>
        <Typography variant="subtitle1" color={grey[500]}>
          {description}
        </Typography>
      </Stack>
      <img src={image} alt={title} style={{ borderRadius: "12px" }} />
    </Stack>
  );
};
